import { useEffect, useState } from "react"
import styled from "styled-components";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

const Container = styled.div`
  position: relative;
`

const Input = styled.input`
  background: ${props => props.disabled ? '#f9f9f9' : '#ffffff'};
  border: ${props => props.$isInvalid ? '1px solid #ef0c0c' : '1px solid #c4c4c4'};
  border-radius: 5px;
  padding: 10px 20px;
  width: ${props => props.$width};
  box-sizing: border-box;
  text-align: left;
  display: flex;
  align-items: center;
  color: #080808;
  font-size: ${props => props.$isMobileView ? '16px' : '14px'};
  outline: 0;
  &:focus {
    border: ${props => props.theme?.borders?.primary || '1px solid rgba(68, 172, 225, 0.7)'};
    box-shadow: ${props => props.theme?.boxShadow?.primary || '0px 0px 3px 2px rgba(68, 172, 225, 0.7)'};
  }
`;

const ArrowBox = styled.div`
  position: absolute;
  top: 2px;
  right: 2px;
  display: flex;
  flex-direction: column;
  height: 33px;
  width: 20px;
`

const Arrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-size: 12px;
  cursor: pointer;
  background: #FCFCFC;
  color: silver;
  user-select: none;

  &:active {
    color: black;
  }
`

const roundToValidValue = (val) => {
  // Undefined, null, and empty string return empty string
  if (val === undefined || val === null || val === '') return ''

  // Convert string to number
  const num = Number(val)

  // Round to nearest 0.25 (using 1 / 0.25 = 4)
  const rounded = Math.round(num * 4) / 4;

  // Non integers become an empty string
  const numOrEmpty = isNaN(rounded) ? '' : rounded

  return numOrEmpty
}

export default function Spinner ({
  value: defaultValue,
  onChange,
  isInvalid = false
}) {
  const [value, setValue] = useState(defaultValue)

  const handleBlur = (val) => {
    const correctedValue = roundToValidValue(val)
    setValue(correctedValue)
  }

  const onIncrement = () => {
    setValue(roundToValidValue(value + 0.25))
  }

  const onDecrement = () => {
    setValue(roundToValidValue(value - 0.25))
  }

  useEffect(() => {
    onChange?.(value)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return (
    <Container style={{ width: '15%', minWidth: 'calc(20px + 4em)' }}>
      <Input
        value={value ?? ''}
        $width='100%'
        $isInvalid={isInvalid}
        onChange={e => setValue(e.target.value)}
        onBlur={e => handleBlur(e.target.value)}
      />
      <ArrowBox>
        <Arrow onClick={onIncrement}><FaAngleUp /></Arrow>
        <Arrow onClick={onDecrement}><FaAngleDown /></Arrow>
      </ArrowBox>
    </Container>
  )
}
